import Vue from 'vue'
import App from './App.vue'
import router from './router'

// Bootstrap CSS
import 'bootstrap/dist/css/bootstrap.css'
import '@/assets/society/css/1200px.css'
import '@/assets/society/css/576px.css'
import '@/assets/society/css/font-awesome.min.css'
import '@/assets/society/css/main.css'

// AOGS2025 specific styles
import '@/assets/aogs2025/css/main.css'
import '@/assets/aogs2025/css/1200px.css'
import '@/assets/aogs2025/css/576px.css'

// 引入自定义样式
import './assets/css/common.css'
import './assets/css/iconfont.css'

// 引入富文本编辑器
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'katex/dist/katex.min.css'

// 为 Quill 公式模块提供全局 KaTeX（用于编辑时弹窗渲染）
import katex from 'katex'
if (typeof window !== 'undefined') {
  window.katex = katex
}

// jQuery
import $ from 'jquery'
window.$ = $

// Bootstrap 5 JavaScript
import * as bootstrap from 'bootstrap'
window.bootstrap = bootstrap

// 导入原始JS文件
import '@/assets/society/js/bootstrap.min.js'
import '@/assets/society/js/main.js'
// 移除 navbartrans.js，因为 CommonNavbar.vue 组件已经处理了导航栏滚动效果
// import '@/assets/society/js/navbartrans.js'

Vue.config.productionTip = false

// 全局加载AOS
Vue.prototype.$initAOS = function() {
  if (window.AOS) {
    window.AOS.init();
  }
}

new Vue({
  router,
  render: h => h(App)
}).$mount('#app') 